module.exports = __webpack_public_path__ + "img/vigour-egger-mini.a97047be.png";